/**
 * Reebok Upsell Checkbox
 * Handles adding an additional product to the cart form when checked.
 * Emits 'upsell:toggle' event for price updates.
 */
class UpsellCheckboxReebok extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="checkbox"]');
        this.hiddenInputs = this.querySelectorAll('[data-upsell-input]');
        this.price = parseInt(this.getAttribute('data-price') || 0);
        
        this._handleChange = this._handleChange.bind(this);
    }

    connectedCallback() {
        if (this.input) {
            this.input.addEventListener('change', this._handleChange);
            // Initialize state
            this._handleChange(); 
        }
    }

    disconnectedCallback() {
        if (this.input) {
            this.input.removeEventListener('change', this._handleChange);
        }
    }

    _handleChange() {
        const isChecked = this.input.checked;

        // Toggle visual state
        this.classList.toggle('is-checked', isChecked);

        // Toggle hidden inputs (enable if checked so they submit with the form)
        this.hiddenInputs.forEach(input => {
            if (isChecked) {
                input.removeAttribute('disabled');
            } else {
                input.setAttribute('disabled', 'true');
            }
        });

        // Dispatch event for other components (price update)
        document.dispatchEvent(new CustomEvent('upsell:toggle', {
            detail: {
                active: isChecked,
                price: this.price
            },
            bubbles: true
        }));
    }
}

customElements.define('upsell-checkbox-reebok', UpsellCheckboxReebok);
